export enum ImageSize {
  "660w" = "size660w",
  "768x768" = "size768x768",
  "1020x680" = "size1020x680",
  "1200x800" = "size1200x800",
  "1280x720" = "size1280x720",
  "1676x943" = "size1676x943",
  "1320w" = "size1320w",
  "landscape250x99" = "sizeLandscape250x99",
}
